import { GeneratedDocumentConnectionInput, SearchTypeEnum } from '@/models/gen/graphql';

import { SearchGeneratedDocumentDocument } from '@/api/queries';
import graphApi from '@/api';

const [, refetchGeneratedDocuments] = graphApi(SearchGeneratedDocumentDocument);

const searchGeneratedDocuments = async (...genDocumentID: string[]) => {
  if (!genDocumentID.length) return [];
  const input: GeneratedDocumentConnectionInput = {
    query: [
      {
        id: [
          {
            values: genDocumentID,
            type: SearchTypeEnum.Or,
            sort: null,
          },
        ],
      },
    ],
  };
  const res = await refetchGeneratedDocuments({ input });
  return (res?.searchGeneratedDocument?.generatedDocumentConnection?.edges || []).map((edge) => edge?.node).filter((node) => node);
};

export default searchGeneratedDocuments;
